import { render, staticRenderFns } from "./RevenueAccruals.vue?vue&type=template&id=2c95442e&scoped=true"
import script from "./RevenueAccruals.vue?vue&type=script&lang=js"
export * from "./RevenueAccruals.vue?vue&type=script&lang=js"
import style0 from "./RevenueAccruals.vue?vue&type=style&index=0&id=2c95442e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c95442e",
  null
  
)

export default component.exports